import { render, staticRenderFns } from "./v-text-field-currency.vue?vue&type=template&id=27148f0c&"
import script from "./v-text-field-currency.vue?vue&type=script&lang=js&"
export * from "./v-text-field-currency.vue?vue&type=script&lang=js&"
import style0 from "./v-text-field-currency.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
